import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {limitSwiperPagination, resolveSliderLayout} from "../../../../eila-global/js/slider/sliderHelpers.js";

export function initProjectBannersSlider() {
    for(const projectBannerSlider of document.querySelectorAll('.projectBanners__slider')) {

        Swiper.use([Autoplay, Navigation, Pagination]);
        const swiper = new Swiper(projectBannerSlider, resolveSliderLayout(projectBannerSlider, {
            grabCursor: true,
            spaceBetween: 24,
            loop: true,
            slideToClickedSlide: true,
            centeredSlides: false,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true
            },
            pagination: {
                el: projectBannerSlider.querySelector(".swiper-pagination"),
                clickable: true,
            },
            navigation: {
                nextEl: projectBannerSlider.closest(".projectBanners").querySelector('.swiper-button-next'),
                prevEl: projectBannerSlider.closest(".projectBanners").querySelector('.swiper-button-prev'),
                addIcons: false
            },
            breakpoints: {
                0: {slidesPerView: 1},
                768: {slidesPerView: 1},
                1025: {slidesPerView: 1.8}
            }
        }));

        limitSwiperPagination(swiper);
    }
}
